<app-user-image text=""></app-user-image>
<div class="h3-semibold-16">Invite new user...</div>
<div>
    <app-custom-input type="email" placeholder="Email"></app-custom-input>
</div>
<div>
    <app-custom-select></app-custom-select>
</div>
<app-custom-button color="primary" text="Invite" type="flat"></app-custom-button>
